<template>
   <div>
      <v-container>
         <v-dialog
            v-model="modal"
            persistent
            width="500px"
            height="550px"
            @keydown.esc="cancelBtnClick"
         >
            <v-sheet height="82vh">
               <v-row>
                  <v-col cols="12">
                     <v-toolbar
                        flat
                        dense
                        :class="$globalstore.toolbar_headerclass"
                     >
                        <v-toolbar-title>
                           <template v-if="$vuetify.breakpoint.mdAndUp">
                              <span>Select Parent</span>
                           </template>
                           <template v-else>
                              Parent
                           </template>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="cancelBtnClick" class="mx-2"
                           >Cancel
                        </v-btn>
                        <v-btn @click.native="OkBtnClick" class="mx-2"
                           >OK
                        </v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-row no-gutters justify="space-around">
                  <v-col cols="8" md="8">
                     <v-btn
                        block
                        color="primary"
                        class="ma-1"
                        @click="allParentBtnClick"
                     >
                        All Parents
                     </v-btn>
                  </v-col>
               </v-row>

               <v-row no-gutters>
                  <v-col cols="12" md="12" class="px-2">
                     <v-text-field
                        label="Search"
                        v-model="parentsearch"
                     ></v-text-field>
                     <v-data-table
                        dense
                        v-model="selectedparents"
                        height="50vh"
                        :headers="parent_header"
                        :items="parentdata"
                        item-key="contact_id"
                        fixed-header
                        @click:row="parentRowClick"
                        :single-select="false"
                        :show-select="true"
                        :search="parentsearch"
                     >
                     </v-data-table>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>
      </v-container>
   </div>
</template>

<script>
   import { RecipientConst } from "@/common/recipientconstant.js";

   export default {
      inject: ["ShowMessage"],

      data() {
         return {
            resolve: null,
            reject: null,
            modal: false,
            rcpttype: RecipientConst.RECIPIENT_TYPE,
            rcptcatglist: RecipientConst.RECIPIENT_CATEGORY,
            rcptgroup: RecipientConst.RECIPIENT_GROUP,
            rcptcode: RecipientConst.RECIPIENT_CODE,
            selectedparents: [],
            selectedrecipient: [],
            parentdata: [],
            parentsearch: "",

            parent_header: [
               {
                  text: "Name",
                  value: "parent_fullname",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Contact ID",
                  value: "contact_id",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },

      methods: {
         parentRowClick(item, row) {
            row.select(!row.isSelected);
         },

         open() {
            this.loadParents();

            this.modal = true;
            return new Promise((resolve, reject) => {
               this.resolve = resolve;
               this.reject = reject;
            });
         },

         allParentBtnClick() {
            let grp = this.rcptgroup.find(
               (x) => x.id === this.rcptcode.ALL_PARENTS
            );

            let recipient = new Array();

            let rcpt = {
               type: this.rcpttype.PARENTS,
               code: this.rcptcode.ALL_PARENTS,
               id: this.rcptcode.ALL_PARENTS,
               text: grp.text,
               color: grp.color,
            };
            recipient.push(rcpt);

            this.resolve(true);
            this.modal = false;
            this.$emit("return-recipient", recipient);
         },

         OkBtnClick() {
            if (this.selectedparents.length > 0) {
               let recipient = new Array();
               for (let i = 0; i < this.selectedparents.length; i++) {
                  var parent = this.selectedparents[i];
                  var grp = this.rcptgroup.find(
                     (x) => x.id === this.rcptcode.INDIVIDUAL_PARENT
                  );
                  let rcpt = {
                     type: this.rcpttype.PARENTS,
                     code: this.rcptcode.INDIVIDUAL_PARENT,
                     id: parent.contact_id,
                     text: parent.parent_fullname,
                     color: grp.color,
                  };
                  recipient.push(rcpt);
                  this.resolve(true);
                  this.modal = false;
                  this.$emit("return-recipient", recipient);
               }
            } else {
               this.resolve(false);
               this.modal = false;
            }
         },

         cancelBtnClick() {
            this.resolve(false);
            this.modal = false;
         },

         async loadParents() {
            await this.$http({
               url: "/common/recipientparent.php",
               headers: { "Content-Type": "application/x-www-form-urlencoded" },
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.parentdata = response.data.parentdata;
                  }
               }
            });
         },
      },
   };
</script>
